import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */

i18next.addResources(locales.EN, 'PUBLIC_PROCEDURES_VIEW', {
  TITLE: 'Beneemeth procedures system',
  SUBTITLE: 'Management of community procedures',
});

/* ------------------------------------- Spanish ------------------------------------- */

i18next.addResources(locales.ES, 'PUBLIC_PROCEDURES_VIEW', {
  TITLE: 'Sistema de trámites Beneemeth',
  SUBTITLE: 'Gestión de trámites comunitarios',
});
